import {SET_IS_THE_OLD_APP_VERSION} from "./types";
import createReducer from "../../utils/createReducer";

const initialState = false

const versionReducer = createReducer(initialState)({
  [SET_IS_THE_OLD_APP_VERSION]: (_, {payload}) => payload,
});

export default versionReducer;